module.exports = __webpack_public_path__ + "static/media/logo.15eee20e.png";